import Scan2Complication from './Scan2Complication';

export default Scan2Complication;